
<template>
    <div
        v-if="!$wait.is('loading-page')"
        class="m-home"
    >
        <y-container>
            <y-slideshow
                type="simple"
                v-bind="responseDot('mainSlideshow.configs')"
            >
                <y-slide
                    v-for="slide in responseDot('mainSlideshow.items')"
                    :key="slide.id"
                >
                    <template v-if="slide.button_link">
                        <a
                            v-if="slide.button_link.startsWith('http') || parseInt(slide.button_external, 10)"
                            :href="slide.button_link"
                            :target="parseInt(slide.button_external, 10) ? '_blank' : '_self'"
                        >
                            <y-image
                                v-if="slide.image"
                                :src="get(slide.image, 'versions.main', slide.image.link)"
                                :alt="slide.title"
                            />
                        </a>
                        <router-link
                            v-else
                            :to="{ path: slide.button_link }"
                        >
                            <y-image
                                v-if="slide.image"
                                :src="get(slide.image, 'versions.main', slide.image.link)"
                                :alt="slide.title"
                            />
                        </router-link>
                    </template>
                    <template v-else>
                        <y-image
                            v-if="slide.image"
                            :src="get(slide.image, 'versions.main', slide.image.link)"
                            :alt="slide.title"
                        />
                    </template>
                </y-slide>
            </y-slideshow>

            <y-list-wrapper
                v-if="responseDot('parentCategories') && responseDot('parentCategories').length"
                type="grid"
                classes="mt-6"
                :component="{
                    classes : 'mt-5',
                    name : 'YCard',
                    type : 'Colorful',
                    imageVersion: 'main',
                }"
                size="6"
                :col="{
                    sm: '4',
                    md: '3',
                }"
                :limit="responseDot('parentCategories').length"
                :items="responseDot('parentCategories')"
                no-scroll
            />

            <y-row class="my-10 py-10">
                <y-col
                    v-if="!!responseDot('ads-top')"
                    :md="emptySpecialSale ? 12 : 4"
                >
                    <y-card
                        type="Colorful"
                        image-version="main"
                        :element="responseDot('ads-top')"
                        :color="get(responseDot('ads-top'), 'custom.color')"
                        :button-content="get(responseDot('ads-top'), 'custom.button_text')"
                        button-color="body"
                        :to="{ path: get(responseDot('ads-top'), 'custom.button_link') }"
                        height="390px"
                        class="m-home__campaign-card mb-5"
                    />
                </y-col>
                <y-col md="8">
                    <y-special-sale
                        type="slideshow"
                        image-version="main"
                        :endpoint="{
                            params: {
                                campaign: 'main'
                            }
                        }"
                        @empty="emptySpecialSale = true"
                    />
                </y-col>
            </y-row>

            <template v-if="responseDot('bestsellers') && responseDot('bestsellers').length">
                <y-section-title
                    type="standard"
                    :title="$t('home.bestsellers_products')"
                    :link="{ name: 'products-list' }"
                    :link-text="$t('home.see_more')"
                    :has-icon="true"
                />
                <y-list-wrapper
                    type="grid"
                    classes="m-home__bestsellers"
                    :component="{
                        classes : 'mt-5',
                        name : 'YProductCard',
                        type : 'Picture',
                    }"
                    size="6"
                    :col="{
                        sm: '4',
                        md: '3',
                    }"
                    :limit="responseDot('bestsellers').length"
                    :items="responseDot('bestsellers')"
                    slide
                />
            </template>

            <y-list-wrapper
                v-if="responseDot('ads-middle') && responseDot('ads-middle').length"
                type="grid"
                class="my-10"
                :component="{
                    classes : 'mt-5 m-home__ads-card',
                    name : 'YCard',
                    type : 'Banner',
                    imageVersion: 'main',
                }"
                size="12"
                :col="{
                    md: (12 / responseDot('ads-middle').length),
                }"
                :limit="responseDot('ads-middle').length"
                :items="responseDot('ads-middle')"
                no-scroll
            />

            <template v-if="responseDot('newProducts') && responseDot('newProducts').length">
                <y-section-title
                    type="standard"
                    :title="$t('home.new_products')"
                    :link="{ name: 'products-list' }"
                    :link-text="$t('home.see_more')"
                    :has-icon="true"
                />
                <y-list-wrapper
                    type="grid"
                    classes="m-home__bestsellers"
                    :component="{
                        classes : 'mt-5',
                        name : 'YProductCard',
                        type : 'Picture',
                    }"
                    size="6"
                    :col="{
                        sm: '4',
                        md: '3',
                    }"
                    :limit="responseDot('newProducts').length"
                    :items="responseDot('newProducts')"
                    slide
                />
            </template>


            <!-- Start Categories -->
            <template v-for="(list, index) in productsCategory">
                <template v-if="list.posts.length || list.loading">
                    <y-section-title
                        :key="`${list.id}-title`"
                        type="standard"
                        :title="list.title"
                        :link="{ name: 'products-category', params: { url_encode: list.url_encode } }"
                        :link-text="$t('home.see_more')"
                        :has-icon="true"
                    />
                    <y-list-wrapper
                        :key="`${list.id}-posts`"
                        type="grid"
                        classes="m-home__bestsellers"
                        :component="{
                            classes : 'mt-5',
                            name : 'YProductCard',
                            type : 'Picture',
                        }"
                        :loading="list.loading"
                        :raised-loading="list.raisedLoading"
                        size="6"
                        :col="{
                            sm: '4',
                            md: '3',
                        }"
                        :limit="list.posts.length"
                        :items="list.posts"
                        slide
                    />
                </template>

                <template v-if="index + 1 === Math.round(productsCategory.length / 2)">
                    <y-list-wrapper
                        v-if="responseDot('ads-bottom') && responseDot('ads-bottom').length"
                        :key="`${list.id}-title-test`"
                        type="grid"
                        class="my-10"
                        :component="{
                            classes : 'mt-5 m-home__ads-card--bottom',
                            name : 'YCard',
                            type : 'Banner',
                            imageVersion: 'main',
                            height: '230px'
                        }"
                        size="12"
                        :col="{
                            md: (12 / responseDot('ads-bottom').length),
                        }"
                        :limit="responseDot('ads-bottom').length"
                        :items="responseDot('ads-bottom')"
                        no-scroll
                    />
                </template>
            </template>
            <!-- End Categories -->

            <template v-if="responseDot('blog') && responseDot('blog').length">
                <y-section-title
                    type="standard"
                    :title="$t('home.blog')"
                    :link="{ name: 'blog-list' }"
                    :link-text="$t('home.all_posts')"
                    :has-icon="true"
                />
                <y-list-wrapper
                    type="grid"
                    classes="m-home__blog"
                    :component="{
                        classes : 'mt-5',
                        name : 'YBlogCard',
                        type : 'Picture',
                        imageVersion: 'main'
                    }"
                    size="12"
                    :col="{
                        md: '4',
                    }"
                    :limit="responseDot('blog').length"
                    :items="responseDot('blog')"
                    no-scroll
                />
            </template>

            <y-list-wrapper
                v-if="responseDot('salesFeatures') && responseDot('salesFeatures').length"
                type="grid"
                class="my-10"
                :component="{
                    classes : 'm-home__sales-feature',
                    name : 'YInfoBox',
                    type : 'Simple',
                    imageVersion: 'main'
                }"
                size="6"
                :col="{
                    md: 3,
                }"
                :limit="responseDot('salesFeatures').length"
                :items="responseDot('salesFeatures')"
                no-scroll
            />
        </y-container>
    </div>
</template>

<script>

    // Mixins
    import PageMixin from '@nodes/mixins/Page';
    import ProductsMixin from '@nodes/mixins/Products';

    // Components
    import {
        YSlideshow, YListWrapper, YSpecialSale, YSectionTitle,
    } from '@rogues';
    import { YSlide, YImage } from '@components';

    export default {

        name: 'HomePage',

        components: {
            YImage,
            YSlide,
            YSlideshow,
            YListWrapper,
            YSpecialSale,
            YSectionTitle,
        },

        mixins: [PageMixin, ProductsMixin],

        /**
         * @inheritDoc
         */
        data() {
            return {
                pageTitle       : this.$t('home.title'),
                emptySpecialSale: false,
                productsResponse: [],

                responses: {
                    mainSlideshow: {
                        configs: {
                            nav           : 10,
                            height        : 'auto',
                            pagination    : 10,
                            paginationNoBg: true,
                            color         : 'white',
                        },
                        items: [],
                    },
                },
            };
        },

        computed: {
            /**
             * Return products list base on selected categories after fetch
             * 
             * @returns {Array}
             */
            productsCategory() {
                if (this.productsResponse && this.productsResponse.length) {
                    return this.productsResponse;
                }

                return this.responseDot('selectedCategories').map((item) => ({
                    id           : item.id,
                    title        : item.title,
                    loading      : true,
                    raisedLoading: true,
                    posts        : [],
                    url_encode   : item.url_encode,
                }));
            },
        },

        /**
         * @inheritdoc
         */
        created() {
            if (this.$route.query.logout) {
                this.$store.dispatch('auth/logout');
            }
        },

        methods: {
            /**
             * Fetch products base on selected categories
             *
             * @returns {*}
             */
            fetchSelectedCategoriesProducts() {
                const finalPostList = [];
                this.responseDot('selectedCategories').forEach((item) => {
                    this.$wait.start('loading-products-categories');
                    finalPostList.push(this.$services.Content.postList({
                        type     : 'products',
                        locale   : this.$i18n.locale,
                        including: ['title', 'image', 'ware_original_price', 'ware_sale_price', 'ware_is_available', 'url_encode', 'published_at'],
                        tagging  : item.id,
                        limit    : 8,
                    }));
                });

                return Promise.all(finalPostList).then((responses) => {
                    responses.forEach((item) => {
                        this.productsResponse.push({
                            id           : this.get(item.data.metadata, 'elected_taggings.0.id'),
                            title        : this.get(item.data.metadata, 'elected_taggings.0.title'),
                            loading      : false,
                            raisedLoading: false,
                            posts        : item.data.results,
                            url_encode   : this.responseDot('selectedCategories')
                                .find((cat) => cat.id === this.get(item.data.metadata, 'elected_taggings.0.id'))?.url_encode,
                        });
                    });
                }).catch((error) => {
                    this.handleError(error);
                }).finally(() => {
                    this.$wait.end('loading-products-categories');
                });
            },

            /**
             * Get data from _this.responses_
             *
             * @param {string} path
             * @param {string} slug - slug of post
             * @param {string} obj - obj of post
             * @returns {*}
             */
            responseDot(path, slug, obj) {
                if (!slug) {
                    return this.get(this.responses, path);
                }
                if (!obj) {
                    return this.get(this.responses, path)?.find((item) => item.slug === slug);
                }
                return this.get(this.responses, path)?.find((item) => item.slug === slug)[obj];
            },
            
            /**
             * Fetch home data
             * 
             * @returns {Promise}
             */
            fetch() {
                this.productsResponse = [];

                const slideshow = this.$services.ContentThemes.slideshowsList({
                    type  : 'slideshow',
                    locale: this.$i18n.locale,
                }).catch((error) => {
                    this.handleError(error);
                });

                const categories = this.$services.Tagging.labels({
                    slug     : 'products-category',
                    locale   : this.$i18n.locale,
                    including: ['title', 'image', 'color', 'selected', 'slug', 'parent_id', 'url_encode'],
                }).catch((error) => {
                    this.handleError(error);
                });

                const bestsellers = this.$services.Content.postList({
                    type     : 'products',
                    locale   : this.$i18n.locale,
                    including: ['title', 'image', 'ware_original_price', 'ware_sale_price', 'ware_is_available', 'url_encode', 'published_at'],
                    sort     : 'sale_count',
                    limit    : 8,
                }).catch((error) => {
                    this.handleError(error);
                });

                const blog = this.$services.Content.postList({
                    type     : 'blog',
                    locale   : this.$i18n.locale,
                    including: ['title', 'image', 'url_encode'],
                    limit    : 3,
                }).catch((error) => {
                    this.handleError(error);
                });

                const ads = this.$services.Content.postList({
                    type     : 'ads',
                    locale   : this.$i18n.locale,
                    including: ['title', 'image', 'slug', 'tagging_labels', 'custom'],
                }).catch((error) => {
                    this.handleError(error);
                });

                const salesFeatures = this.$services.Content.postList({
                    type     : 'sales-features',
                    locale   : this.$i18n.locale,
                    including: ['title', 'image', 'custom'],
                }).catch((error) => {
                    this.handleError(error);
                });

                const newProducts = this.$services.Content.postList({
                    type     : 'products',
                    locale   : this.$i18n.locale,
                    including: ['title', 'image', 'ware_original_price', 'ware_sale_price', 'ware_is_available', 'url_encode', 'published_at'],
                    limit    : 8,
                }).catch((error) => {
                    this.handleError(error);
                });

                return Promise.all([slideshow, categories, bestsellers, blog, ads, salesFeatures, newProducts]).then((responses) => {
                    if (this.handleReq(responses, 0)) {
                        this.set(this.responses, 'mainSlideshow.configs', {
                            ...this.responses.mainSlideshow.configs,
                            effect       : responses[0].data.metadata.configs.effect,
                            loop         : !!responses[0].data.metadata.configs.loop,
                            autoplay     : !!responses[0].data.metadata.configs.autoplay,
                            direction    : responses[0].data.metadata.configs.direction,
                            slidesPerView: responses[0].data.metadata.configs.slides_per_view,
                            speed        : responses[0].data.metadata.configs.speed,
                            spaceBetween : parseInt(responses[0].data.metadata.configs.space_between, 10),
                        });
                        this.set(this.responses, 'mainSlideshow.items', responses[0].data.results);
                    }

                    if (this.handleReq(responses, 1)) {
                        this.set(this.responses, 'parentCategories', responses[1].data.results.filter((item) => !item.parent_id)
                            .map((post) => ({
                                ...post,
                                tag: 'router-link',
                                to : { name: 'products-category', params: { url_encode: post.url_encode } },
                            })));
                        this.set(this.responses, 'selectedCategories', responses[1].data.results.filter((item) => item.selected));

                        this.fetchSelectedCategoriesProducts();
                    }

                    if (this.handleReq(responses, 2)) {
                        this.set(this.responses, 'bestsellers', responses[2].data.results);
                    }

                    if (this.handleReq(responses, 3)) {
                        this.set(this.responses, 'blog', responses[3].data.results);
                    }

                    if (this.handleReq(responses, 4)) {
                        this.set(this.responses, 'ads-top', responses[4].data.results.find((item) => item.slug === 'banner-1'));
                        this.set(this.responses, 'ads-middle', responses[4].data.results
                            .filter((item) => item.tagging_labels.find((tag) => tag.slug === 'homepage-middle'))
                            .map((post) => ({
                                ...post,
                                title        : null,
                                buttonContent: post.custom.button_text,
                                buttonColor  : 'white',
                                buttonSize   : 'normal',
                                noOverlay    : true,
                                buttonTag    : post.custom.button_link.startsWith('http') ? 'a' : 'router-link',
                                to           : post.custom.button_link.startsWith('http') ? null : { path: post.custom.button_link },
                                href         : post.custom.button_link.startsWith('http') ? post.custom.button_link : null,
                            })));

                        this.set(this.responses, 'ads-bottom', responses[4].data.results
                            .filter((item) => item.tagging_labels.find((tag) => tag.slug === 'homepage-bottom'))
                            .map((post) => ({
                                ...post,
                                title        : null,
                                buttonContent: post.custom.button_text,
                                buttonColor  : 'white',
                                buttonSize   : 'normal',
                                noOverlay    : true,
                                buttonTag    : post.custom.button_link.startsWith('http') ? 'a' : 'router-link',
                                to           : post.custom.button_link.startsWith('http') ? null : { path: post.custom.button_link },
                                href         : post.custom.button_link.startsWith('http') ? post.custom.button_link : null,
                            })));
                    }

                    if (this.handleReq(responses, 5)) {
                        this.set(this.responses, 'salesFeatures', responses[5].data.results.map((post) => ({
                            ...post,
                            img : post.image,
                            link: post.custom.link ? post.custom.link : null,
                            tag : post.custom.link ? 'a' : 'div',
                        })));
                    }

                    if (this.handleReq(responses, 6)) {
                        this.set(this.responses, 'newProducts', responses[6].data.results);
                    }
                }).catch((error) => {
                    this.handleError(error);
                });
            },
        },

    };
</script>
